import { useEffect, useState } from "react";
import { FaArrowUpLong } from "react-icons/fa6";

const BackToTop = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    const handleScroll = () => {
        if (window.scrollY >= 200) {
            setShowScrollTop(true);
        } else {
            setShowScrollTop(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div
            className={`fixed bottom-8 right-8 z-50 flex size-10 items-center justify-center rounded-md  bg-secondary-color duration-200 cursor-pointer ${
                showScrollTop
                    ? "translate-y-0 opacity-100"
                    : "translate-y-20 opacity-0"
            }`}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Back to top"
        >
            <FaArrowUpLong className="size-4 text-white" />
        </div>
    );
};

export default BackToTop;